import React from "react";
import {
    Typography,
    Paper,
    Divider,
    List,
    makeStyles,
} from "@material-ui/core";

import MainScreen from "./templates/MainScreen";
import { useTranslation } from "react-i18next";
import NewNotification from "../components/NewNotification";
import { UserContext } from "../../viewmodel/providers/user-context";
import { LowerbarState } from "../../model/lowerBarState";
import routes from "../../utils/apiRoutes.json";

const useStyles = makeStyles((theme) => ({
    blackElem: {
        backgroundColor: theme.palette.primary.main,
    },
}));

export default function NotificationsPanel(): JSX.Element {
    const { t } = useTranslation();
    const classes = useStyles();
    const notifications = React.useContext(UserContext).notifications;
    

    const notificationsComponents = notifications.map((item, i) =>
        <NewNotification key={i} notification={item} type={item.type} />,
    );

    return (
        <MainScreen lower={true} back={true} backPath={routes.menu} lowerBarState={LowerbarState.NOTIFICATIONS}>
            <Paper style={{ overflow: "auto" }} elevation={0}>
                <Typography variant="h6">
                    {t("notifications-panel.invites")}
                </Typography>
                <Divider orientation="horizontal" classes={{ root: classes.blackElem }} />
                <List>
                    {notificationsComponents}
                </List>
            </Paper>
        </MainScreen>
    );
}
